import { render, staticRenderFns } from "./DailyTask.vue?vue&type=template&id=e78c4b56&"
import script from "./DailyTask.vue?vue&type=script&lang=js&"
export * from "./DailyTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports